<script>
import { BModal } from "bootstrap-vue";

export default {
  extends: BModal
};
</script>